<template>
  <section v-loading.fullscreen.lock="loading" class="square">
    <el-backtop target=".square" :bottom="100" :visibility-height="1" />
    <div class="row">
      <div class="menu">
        <p
          v-for="(item,index) in learnInfo.obj.tabs"
          :key="index"
          :class="[active===index?'active': '']"
          @click="menuChange(item,index)">
          {{ item.name }}
        </p>
      </div>
      <el-input
        v-model="search"
        class="searchInput"
        placeholder="请输入关键字"
        size="small"
        suffix-icon="el-icon-search"
        @change="searchFn"
      />
    </div>
    <div class="square-data">
      <template v-if="data2&&data2.length">
        <div v-for="(item2, index2) in data2" :key="index2" class="cell-item">
          <el-card :body-style="{ padding: '0px' }" shadow="hover">
            <div class="box">
              <div class="imgBox" @click="openVideo(item2)">
                <img :src="item2.img" alt="">
              </div>

              <div class="name">
                {{ item2.name }}
              </div>
              <i class="el-icon-video-play" @click="openVideo(item2)" />
            </div>
          </el-card>
        </div>
      </template>

      <template v-else>
        <div class="nullData">
          <NullData
            text="相关空间正在更新中,敬请期待!"
          />
        </div>
      </template>
    </div>
    <div class="pagination ">
      <el-pagination
        class="fun-pagination"
        :current-page="requestParams.page"
        :page-sizes="[9, 18, 27, 36]"
        :page-size="requestParams.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      title=" "
      :visible.sync="dialogVisible"
      :fullscreen="true"
      :before-close="handleClose"
    >
      <video :src="pathValue" controls="controls" width="100%" height="100%" autoplay />
    </el-dialog>
  </section>
</template>

<script>
import api from '@/api/app'
import mock from '@/utils/mock'
import NullData from '@/components/NullData'
export default {
  components: { NullData },
  data() {
    return {
      learnInfo: mock.learn.learn.viewInfo,
      active: 0,
      search: null,
      total: null,
      requestParams: {
        page: 1,
        page_size: 9,
        type: 1,
        search: ''
      },
      data2: null,
      loading: false,
      timer: null,
      dialogVisible: false,
      pathValue: ''
    }
  },
  computed: {
    itemWidth() {
      return 78.75 * (document.documentElement.clientWidth / 375)
    }
  },
  async created() {
    this.loading = true
    this.init()
    // 筛选项
  },
  mounted() {

  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    async init() {
      this.loading = true
      if (this.active == 0) {
        this.requestParams.type = 1
      } else if (this.active == 1) {
        this.requestParams.type = 2
      } else {
        this.requestParams.type = 3
      }
      api.system.learn(this.requestParams).then((res) => {
        this.data2 = res.data.data
        this.total = res.data.total
        this.loading = false
      })
    },
    menuChange(item, index) {
      this.active = index
      this.requestParams.page = 1
      this.init()
    },
    handleSizeChange(val) {
      this.requestParams.page_size = val
      this.init(this.requestParams)
    },
    handleCurrentChange(val) {
      this.requestParams.page = val
      this.init(this.requestParams)
    },
    handleClose() {
      this.dialogVisible = false
      this.pathValue = ''
    },
    openVideo(item) {
      this.dialogVisible = true
      this.pathValue = item.url
    },
    searchFn(e) {
      console.log(e)
      this.requestParams.search = e
      this.init()
    }
  }
}
</script>

  <style scoped lang="scss">
  .square {
    background-color: #f6f6f6;
    padding: 0 34px 10px 34px;
    // overflow-y: scroll;
    // height: calc(100vh - 120px);
    // min-height: calc(100vh - 120px) ;
    .row{
      position: relative;
      right: 0;
    }
    .searchInput{
      position: absolute;
      width: 208px;
      right: 0;
      top: 0;
    }
    .menu{
      margin-top: 32px;
      display: flex;
      align-items: center;
      width: 100%;
      p{
        margin-right: 16px;
        color: #333;
        padding: 7px 16px;
        border-radius: 6px;
        cursor: pointer;
      }
      .active{
        color:#fff ;
        background-color: #2f82ff;
      }
    }
    &-search {
      background-color: #fff;
      border-radius: 22px;
      width: $xr-min-width;
      // margin-left: 17%;
      padding: 20px;
      margin-top: 20px;
    }
    &-data {
      @include fun-layout();
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: flex-start;
      overflow: unset;
      min-height: 890px;
    }
  }
  .cell-item{
    margin-right: 5px;
    &:nth-child(3n){
      margin-right: unset;
    }
  }
  .cell-item /deep/ .card1-content {
    padding: 5% 2%;
    margin-right: 20px;
  }
  .cell-item /deep/ .card1-img {
    margin-right: 20px;
  }
  .cell-item {
    width: 33%;
  }
  .square-title {
    height: 78px;
    background-color: #f6f6f6;
    width: $xr-min-width;
    position: sticky;
    top: 0;
    margin: 0 auto;
  }
  .nullData {
    margin: 0 auto;
    margin-top: 10vh;
    color: #909399;
  }
  .square /deep/ .el-dialog__body{
    height: calc(100% - 30px) !important;
  }
.box{
  width: 100%;
  position: relative;


  .imgBox{
      width: 100%;
      height:217px;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      img{
        width: 100%;
       height: 100%;
      }
    }
    .name{
      padding: 10px 20px;
      background-color: #fff;
      height: 56px;

    }
    i{
      cursor: pointer;
      font-size: 45px;
    color: #fff;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    }
 }
 .el-card{
  margin-top: 20px;
 }
 .pagination{
  text-align: right;
  margin-top: 20px;
 }
  </style>

